export default __webpack_public_path__ + "static/media/BG_Shape_1.165ad337.png";